import { render, staticRenderFns } from "./reproduce.vue?vue&type=template&id=21891b0a&scoped=true"
import script from "./reproduce.vue?vue&type=script&lang=js"
export * from "./reproduce.vue?vue&type=script&lang=js"
import style0 from "./reproduce.vue?vue&type=style&index=0&id=21891b0a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21891b0a",
  null
  
)

export default component.exports